<section class="hero inner-pages">
  <div class="base-fit">
    <img src="/assets/images/about/hero.png">
  </div>
  <div class="text-wrapper">
    <h2 class="text-center">{{pageTitle}}</h2>
  </div>
</section>
<div class="page-content">
  <section>
    <div class="container">
      <div class="card jobs-list mb-4">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/" class="color-gray4">{{'header.Home' | translate}}</a></li>
            <li class="breadcrumb-item active color-gray4 font-700">{{pageTitle}}</li>
          </ol>
        </nav>

        @if (dataLoading) {
        <div class="d-flex h-100 py-5">
          <div class="py-5 m-auto">
            <div class="spinner-border"></div>
          </div>
        </div>
        }
        @else {
        <div class="data-empty py-5" *ngIf="!jobs.length">
          <img src="assets/images/icons/empty.svg" alt="">
          <h3>{{'general.No jobs found' | translate}}</h3>
        </div>

        <div class="row" *ngIf="jobs.length">
          <div class="col-sm-6" *ngFor="let item of jobs; index as i"
            data-aos="fade-up" [attr.data-aos-delay]="100*(i%6)">
            <div class="card">
              <div class="card-body">
                <div class="head">
                  <div class="title mb-2">
                    <div class="image">
                      @if (item.company.image) {
                      <img [src]="item.company.image" alt="" (error)='item.company.image = ""'>
                      } @else {
                      <img style="width: 2rem; margin-bottom: 0;" src="assets/images/icons/company_1-copy.svg" alt="">
                      }
                    </div>
                    <div>
                      <h5 class="font-22 font-700 color-gray0 mb-1">{{item.job_title}}</h5>
                      <h6 class="font-16 color-gray4 m-0">{{item.company.name}}</h6>
                    </div>
                  </div>
                </div>

                <div class="content">
                  <div class="mb-2">
                    <img style="width: 1rem;" src="assets/images/icons/clarity_date-line.svg" alt="">
                    <span class="ms-2 font-15 font-700 color-gray2">{{item.created_at | timeAgo}}</span>
                  </div>
                  <div class="mb-2">
                    <div class="badge badge-primary">
                      <img style="width: 0.9rem;" src="assets/images/icons/time.svg" alt="">
                      <span class="ms-1">
                        @if (item.employment_type == 'Full-Time') {
                        {{'jobs.FullTime' | translate}}
                        }
                        @if (item.employment_type == 'Part-Time') {
                        {{'jobs.PartTime' | translate}}
                        }
                        @if (item.employment_type == 'Contract') {
                        {{'jobs.Contract' | translate}}
                        }
                        @if (item.employment_type == 'Internship') {
                        {{'jobs.Internship' | translate}}
                        }
                        @if (item.employment_type == 'Freelance') {
                        {{'jobs.Freelance' | translate}}
                        }
                      </span>
                    </div>
                    <div class="badge badge-primary ms-2">
                      <img style="width: 0.9rem;" src="assets/images/icons/company_1.svg" alt="">
                      <span class="ms-1">
                        @if (item.work_mode == 'Onsite') {
                        {{'jobs.Work from site' | translate}}
                        }
                        @if (item.work_mode == 'Hybrid') {
                        {{'jobs.Hybrid' | translate}}
                        }
                        @if (item.work_mode == 'Remote') {
                        {{'jobs.Work from home' | translate}}
                        }
                      </span>
                    </div>
                  </div>
                  <div>
                    <!-- <div class="badge badge-gray0 px-2 me-2"
                        *ngFor="let comp of item.competences; index as i">
                      <img style="width: 0.9rem;" src="assets/images/icons/solution-strategy-icon.svg" alt="">
                      <span class="ms-1">{{comp.name}}</span>
                    </div> -->
                    <div class="badge badge-gray0 px-2 me-2"
                      *ngFor="let comp of item.competences; index as i" [hidden]="i > 4"
                      [class.opacity-50]="!comp.selected">{{comp.name}}</div>
                    <button class="badge badge-gray0 border-0 px-2"
                      *ngIf="item.competences.length > 5"
                      (click)="showComp(item)">...</button>
                  </div>
                </div>
              </div>
              <div class="foot d-block">
                <div class="row">
                  <div class="col-6 m-auto">
                    <a href="{{env.appUrl}}/auth/jobs/search/{{item.id}}" class="btn btn-primary w-100">{{'jobs.Apply now' | translate}}</a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </section>

  <div class="text-center my-5 px-4" *ngIf="pageIndx < listData?.pagination?.totalPages">
    <div class="row justify-content-center">
      <div class="col-sm-4 col-lg-3 col-8">
        <button class="btn btn-primary w-100" (click)="loadMore()">{{'general.Load more' | translate}}</button>
      </div>
    </div>
  </div>
</div>
